import { render } from "./v-user-menu.vue?vue&type=template&id=105bb415&scoped=true"
import script from "./v-user-menu.vue?vue&type=script&lang=js"
export * from "./v-user-menu.vue?vue&type=script&lang=js"

import "./v-user-menu.vue?vue&type=style&index=0&id=105bb415&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105bb415"]])

export default __exports__